export { default } from "./WholeClassAssignmentOptions";
